import { websiteLink } from '../../lib/website';

/**
 * **An organisation's website, as a link out of the app** (owner ruling,
 * 2026-09-10). The host is what the reader sees; the address is where it goes.
 *
 * `target="_blank"` with `rel="noopener noreferrer"`: the record stays where it
 * was — this is the one thing on the page that is *not* about the record, so
 * taking the reader off it would be the page losing their place — and the tab it
 * opens gets no handle on this one and tells the site nothing about where the
 * reader came from.
 *
 * **A value that is not a readable address is printed as text.** The stated
 * website of an organisation the office has never confirmed a site for is
 * whatever a page said, and a link offering to take somebody to a string nobody
 * can resolve is worse than the string.
 */
export function SiteLink({ value }: { value: string }) {
  const link = websiteLink(value);
  if (!link) return <>{value}</>;

  return (
    <a className="link" href={link.href} target="_blank" rel="noopener noreferrer">
      {link.host}
    </a>
  );
}
